import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { useTranslation } from "react-i18next"

const PaginationBtn = styled(Link)`
  padding: 6px 12px;
  margin-left: -1px;
  color: #337ab7;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
  display: inline-block;

  &.active {
    background-color: #2cabe3;
    border-color: #2cabe3;
    color: white;
  }

  &[disabled] {
      pointer-events: none;
      cursor: not-allowed;
      background-color: #fff;
      color: #777;
  }

  &.prevBtn {
  }

  &.nextBtn {
  }
`

const Pagination = ({
  isFirst,
  isLast,
  prevPage,
  nextPage,
  totalPages,
  locale,
  currentPage,
  currentBaseUrl
}) => {
  const { t } = useTranslation()
  //   const { isFirst, isLast, prevPage, nextPage, totalPages, locale } = props
  const activePage = currentPage - 1;
  return (
    <div style={{ display: "inline-block", margin: "20px 0" }}>
      <PaginationBtn to={prevPage} rel="prev" disabled={isFirst}>
        {t("page_previous")}
      </PaginationBtn>
      {Array.from({ length: totalPages }, (_, i) => (
        <PaginationBtn
          className={activePage === i ? "active" : ""}
          key={`pagination-number${i + 1}`}
          to={`${currentBaseUrl}/${i === 0 ? "" : i + 1}`}
        >
          {i + 1}
        </PaginationBtn>
      ))}
      <PaginationBtn to={nextPage} rel="next" disabled={isLast}>
        {t("page_next")}
      </PaginationBtn>
    </div>
  )
}

export default Pagination
